module.exports = __webpack_public_path__ + "img/honer16.58fe323a.jpg";